import {isNumber} from "lodash/lang";

/**
 * Updates custom progress bar progress
 *
 * @param {HTMLElement} element
 * @param {number|string} progress
 */
function updateProgressBar(element, progress) {
	// Turn into string
	if (isNumber(progress)) {
		progress = progress.toFixed(0);
	}

	const progressAsInt = parseInt(progress);

	// Update texts
	const progressPercentage = `${progress}%`;

	element.querySelectorAll('.text-when-full,.text-when-empty').forEach(textElement => {
		textElement.innerText = progressPercentage
	})

	// Update bar width
	// noinspection JSUnresolvedReference
	element.querySelector('.bar').style.width = progressPercentage;


	const textWhenFull = element.querySelector('.text-when-full')
	// Update bar text location to keep it centered
	if (progressAsInt > 0.1) {
		// Calculate text position
		const leftPosition = (0.5 + ((50 - (progressAsInt * 0.5)) / progressAsInt)) * 100;
		textWhenFull.style = `left: ${leftPosition}%; opacity: 1`;
	} else {
		// Hide text
		textWhenFull.style = 'left: 0; opacity: 0';
	}
}

export {updateProgressBar}
